import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UrlConstants } from "../models/urlConstants";
import { Observable, of, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { map } from 'rxjs/operators';
import { checkSettingWithMarketId } from "../models/settingsWithMarket";

@Injectable({
  providedIn: "root",
})
export class SystemSettingsService  {
  readonly SETTINGS_API="/api/Settings/";
  constructor(private http: HttpClient) { }

      checkSetting(key:string): Observable<boolean> {
        return this.http.get<{ key: string, value: string }>(`${UrlConstants.backofficeUrl}${this.SETTINGS_API}GetSystemSetting?key=${key}`)
          .pipe(
            map(response => String(response?.value).toLowerCase() === 'true'),
            catchError(error => {
              return of(false);
            })
          );
      }
     checkSettingWithMarketId(req:checkSettingWithMarketId): Observable<boolean> {
        return this.http.post<{ key: string, value: string }>(`${UrlConstants.backofficeUrl}${this.SETTINGS_API}GetSystemSettingWithMarketId`,req)
          .pipe(
            map(response => String(response?.value).toLowerCase() === 'true'),
            catchError(error => {
              return of(false);
            })
          );
      }
      checkCompanyName(key:string): Observable<{ key: string, value: string }> {
        return this.http.get<{ key: string, value: string }>(`${UrlConstants.backofficeUrl}${this.SETTINGS_API}GetSystemSetting?key=${key}`)
      }
            checkDefaultCurr(key:string): Observable<{ key: string, value: string }> {
        return this.http.get<{ key: string, value: string }>(`${UrlConstants.backofficeUrl}${this.SETTINGS_API}GetSystemSetting?key=${key}`)
      }

}
